<template>
  <b-row>
    <b-col sm="12" md="6">
      <b-form-input
        type="search"
        placeholder="Número pedido, cliente o SKU"
      ></b-form-input>
    </b-col>
    <b-col sm="12" md="2">
      <!-- class="mb-2 mr-sm-2 mb-sm-0" -->
      <b-form-select
        :options="[{ text: 'Origen...', value: null }, 'One', 'Two', 'Three']"
        :value="null"
      ></b-form-select>
    </b-col>
    <b-col sm="12" md="2">
      <b-form-select
        :options="[{ text: 'Fecha...', value: null }, 'One', 'Two', 'Three']"
        :value="null"
      ></b-form-select>
    </b-col>
    <b-col sm="12" md="2">
      <b-form-select
        :options="[{ text: 'Etiqueta...', value: null }, 'One', 'Two', 'Three']"
        :value="null"
      ></b-form-select>
    </b-col>
  </b-row>
  <!-- <div>
    <b-icon-search class="filter-icon"></b-icon-search>
    <b-form-tags
      class="filter-text"
      v-model="keyword"
      separator=","
      remove-on-delete=""
      placeholder="Nombre o SKU"
      @keydown.native.enter="updateKeyword"
      @keydown.native.delete="cleanSearch"
      @input="cleanSearch"
    ></b-form-tags>
  </div> -->
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "OrdersFilters",
  data() {
    return {
      keyword: []
    };
  },
  computed: {
    ...mapState(["filters"])
  },
  methods: {
    ...mapMutations(["setFilter"]),
    updateKeyword() {
      this.setFilter({ keyword: this.keyword.join(",") });
    },
    cleanSearch() {
      if (!this.keyword.length) {
        this.updateKeyword();
      }
    }
  },
  watch: {
    filters(newValue, oldValue) {
      const oldKeyword = oldValue.keyword;
      const newKeyword = newValue.keyword;
      if (oldKeyword !== newKeyword && this.keyword.join(",") !== newKeyword) {
        this.keyword = newKeyword.split(",");
      }
    }
  }
};
</script>
